import { User } from 'src/types/auth';

export const parseAuthId = (id?: string | number | null): number | null => {
  if (id == null) {
    return null;
  }
  const parsed = Number(id);
  return Number.isNaN(parsed) ? null : parsed;
};

export const isImpersonatingSession = (
  loggedInUserId?: string | number | null,
  clientId?: string | number | null
): boolean => {
  if (loggedInUserId == null || clientId == null) {
    return false;
  }
  return String(loggedInUserId) !== String(clientId);
};

type ImpersonationUser = Pick<User, 'LoggedInUserId' | 'ClientId' | 'CompanyId'> | null | undefined;

export const isUserImpersonating = (user: ImpersonationUser): boolean =>
  isImpersonatingSession(user?.LoggedInUserId, user?.ClientId);

export const getImpersonatedCompanyIdFromUser = (user: ImpersonationUser): number | null => {
  if (!isUserImpersonating(user) || user?.CompanyId == null) {
    return null;
  }
  return parseAuthId(user.CompanyId);
};

export const getImpersonatedClientIdFromUser = (user: ImpersonationUser): number | null => {
  if (!isUserImpersonating(user) || user?.ClientId == null) {
    return null;
  }
  return parseAuthId(user.ClientId);
};

export const getSessionClientId = (clientId?: string | number | null): number | null =>
  parseAuthId(clientId);

/** True when the row belongs to the active session user (token ClientId). */
export const isSessionClientId = (
  rowClientId: number | null | undefined,
  sessionClientId: number | null
): boolean => {
  if (sessionClientId == null || rowClientId == null) {
    return false;
  }
  return Number(rowClientId) === sessionClientId;
};

/** @deprecated Use isSessionClientId with sessionClientId from auth context. */
export const isImpersonatedClientId = isSessionClientId;
